import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import DetectionPage from './pages/DetectionPage';
import ResultPage from './pages/ResultPage';
import HistoryPage from './pages/HistoryPage';
import RedirectPage from './pages/RedirectPage';
import { getGuestUser } from './utils/guestUser';
import WeChatBrowserTip from './components/WeChatBrowserTip';
import './App.css';

function App() {
  const [currentUser, setCurrentUser] = useState(null);

  // 从localStorage恢复用户信息（包括游客用户）
  useEffect(() => {
    const savedUser = localStorage.getItem('currentUser');
    if (savedUser) {
      setCurrentUser(JSON.parse(savedUser));
    } else {
      // 尝试恢复游客用户
      const guestUser = getGuestUser();
      if (guestUser) {
        setCurrentUser(guestUser);
      }
    }
  }, []);

  // 保存用户信息到localStorage
  const saveUser = (user) => {
    setCurrentUser(user);
    if (user.isGuest) {
      // 游客用户不保存到currentUser，只保存到guestUser
      localStorage.setItem('guestUser', JSON.stringify(user));
    } else {
      localStorage.setItem('currentUser', JSON.stringify(user));
    }
  };

  return (
    <Router>
      <div className="App">
        <WeChatBrowserTip />
        <Routes>
          <Route path="/" element={<HomePage currentUser={currentUser} setCurrentUser={saveUser} />} />
          <Route
            path="/detection"
            element={<DetectionPage currentUser={currentUser} setCurrentUser={saveUser} />}
          />
          <Route path="/result/:reportId" element={<ResultPage currentUser={currentUser} />} />
          <Route
            path="/history"
            element={<HistoryPage currentUser={currentUser} setCurrentUser={saveUser} />}
          />
          <Route path="/redirect" element={<RedirectPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;

